import { Typography } from "antd";
import { Monitor, PageLayout } from "components";
import { useParams } from "react-router-dom";

const MonitorPage = (props) => {
    const { monitorItem, itemAction, itemId } = useParams();
    return (
        <PageLayout
            mainContent={({ setBreadcrumbNavigationItems }) => {
                return <Monitor activeItem={monitorItem} setBreadcrumbNavigationItems={setBreadcrumbNavigationItems}></Monitor>;
            }}
            helpContent={<Typography>We're working on this documentation.</Typography>}
        ></PageLayout>
    );
};

export default MonitorPage;
